module.exports = __webpack_public_path__ + "img/img4_2.e14303ad.jpeg";